<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.section-card {

}
</style>

<template>
    <div class="section-card w-100">
        <a class="d-inline-block w-100 p-24" :href="section.url">
            <h3 class="mb-40" v-html="section.title.rendered"></h3>
            <p>{{ section.description }}</p>
            <span class="read-more">{{ translations.read_more }}</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        section: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
    },
}
</script>